module.exports = __webpack_public_path__ + "210935078ba6b721e1544ea1a461090d.svg";